import { useState } from 'react'

import { Box, Divider, Flex } from '@chakra-ui/react'
import { ItList } from 'types/graphql'

import { navigate, routes } from '@redwoodjs/router'

import AudioPlayerInline from 'src/components/widgets/AudioPlayerInline/AudioPlayerInline'
import ItListImage from 'src/components/widgets/ItListImage/ItListImage'
import { VoiceTipAnalyticsProps } from 'src/lib/hooks/analytics/useAnalytics'
import { getBrandColor, getFullName } from 'src/lib/utils'

const Intro = ({
  itList,
  isPreview,
  trackingData,
}: {
  itList: ItList
  isPreview: boolean
  trackingData: VoiceTipAnalyticsProps
}) => {
  const creator = itList.creator
  const brandColor = getBrandColor(creator)
  const [opacity, setOpacity] = useState(1)

  const navToProfile = () => {
    navigate(routes.profile({ username: creator.username }))
  }

  return (
    <Box px={{ base: 4, lg: isPreview ? 4 : 24 }}>
      <Box
        as="h3"
        className="thick"
        color={itList.name ? 'onyx' : 'graphite'}
        data-testid="itListDetails-title"
        id="it-list-item-title"
      >
        {itList.name || 'Untitled ItList...'}
      </Box>
      <Divider mt={6} mb={4} color="vapor" />
      <Flex gap={6} alignItems="center" maxW="100%">
        <ItListImage
          alt="ItList's creator profile image"
          htmlHeight={44}
          htmlWidth={44}
          opacity={opacity}
          transition="opacity 0.2s ease"
          src={creator.profileImage}
          borderRadius="full"
          boxSize="44px"
          flexShrink={0}
          onClick={navToProfile}
          cursor="pointer"
          data-testid="itListDetails-profileImage"
        />
        <Flex
          onClick={navToProfile}
          cursor="pointer"
          opacity={opacity}
          transition="opacity 0.2s ease"
          direction="column"
          flexGrow={1}
          overflow="hidden"
        >
          <Box
            className="body-small-emphasis"
            textOverflow="ellipsis"
            overflow="hidden"
            whiteSpace="nowrap"
            data-testid="itListDetails-fullname"
          >
            By: {getFullName(creator)}
          </Box>
          <Box
            className="body-extra-small-emphasis"
            color={brandColor}
            textOverflow="ellipsis"
            overflow="hidden"
            whiteSpace="nowrap"
            data-testid="itListDetails-username"
          >
            @{creator.username}
          </Box>
        </Flex>
        {itList.hasVoiceIntro && (
          <Box flexShrink={0}>
            <AudioPlayerInline
              mediaUrl={itList.voiceIntroUrl}
              title={itList.name}
              pictureUrl={creator.profileImage}
              brandColor={brandColor}
              onPlay={() => setOpacity(0.1)}
              onStop={() => setOpacity(1)}
              veneerLabel="INTRO"
              trackingData={trackingData}
            />
          </Box>
        )}
      </Flex>
      <Divider mt={4} mb={6} color="vapor" />
    </Box>
  )
}

export default Intro
